import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { 
  UserPlus, 
  Search, 
  QrCode, 
  TrendingUp,
  ArrowRight 
} from 'lucide-react';
import '../../../assets/styles/customer/layout/HowItWorksSection.css';

const HowItWorksSection = () => {
  const steps = [
    {
      id: 1,
      number: '01',
      icon: <UserPlus size={40} strokeWidth={1.8} />,
      title: 'Create Account',
      description: 'Sign up as a customer or distributor in just 2 minutes with your basic details.',
      color: '#3e96e7'
    },
    {
      id: 2,
      number: '02',
      icon: <Search size={40} strokeWidth={1.8} />,
      title: 'Find & Connect',
      description: 'Customers browse nearby distributors, view prices, and send subscription requests.',
      color: '#4caf50'
    },
    {
      id: 3,
      number: '03',
      icon: <QrCode size={40} strokeWidth={1.8} />,
      title: 'Get Your QR Code',
      description: 'Once approved, receive your unique QR code for seamless daily delivery tracking.',
      color: '#3e96e7'
    },
    {
      id: 4,
      number: '04',
      icon: <TrendingUp size={40} strokeWidth={1.8} />,
      title: 'Track & Pay',
      description: 'View daily delivery logs, monthly summaries, and settle dues easily.',
      color: '#00bcd4'
    }
  ];

  return (
    <section className="how-it-works-section">
      
      {/* Floating Milk Bottles Background */}
      <div className="floating-milk-bottles">
        <div className="milk-bottle bottle-float-1">🥛</div>
        <div className="milk-bottle bottle-float-2">🥛</div>
        <div className="milk-bottle bottle-float-3">🥛</div>
        <div className="milk-bottle bottle-float-4">🥛</div>
      </div>

      {/* Wavy Background Layers */}
      <div className="wavy-background">
        <svg className="wave-layer layer-1" viewBox="0 0 1440 320" preserveAspectRatio="none">
          <path fill="rgba(62, 150, 231, 0.05)" d="M0,96L48,106.7C96,117,192,139,288,138.7C384,139,480,117,576,117.3C672,117,768,139,864,138.7C960,139,1056,117,1152,106.7C1248,96,1344,96,1392,96L1440,96L1440,320L1392,320C1344,320,1248,320,1152,320C1056,320,960,320,864,320C768,320,672,320,576,320C480,320,384,320,288,320C192,320,96,320,48,320L0,320Z"></path>
        </svg>
        <svg className="wave-layer layer-2" viewBox="0 0 1440 320" preserveAspectRatio="none">
          <path fill="rgba(76, 175, 80, 0.03)" d="M0,160L48,170.7C96,181,192,203,288,197.3C384,192,480,160,576,154.7C672,149,768,171,864,181.3C960,192,1056,192,1152,181.3C1248,171,1344,149,1392,138.7L1440,128L1440,320L1392,320C1344,320,1248,320,1152,320C1056,320,960,320,864,320C768,320,672,320,576,320C480,320,384,320,288,320C192,320,96,320,48,320L0,320Z"></path>
        </svg>
      </div>

      <Container>
        
        {/* Section Header */}
        <div className="works-header text-center">
          <div className="badge-pill">Simple Process</div>
          <h2 className="works-title">
            How <span className="title-brand">MilkFlow</span> Works
          </h2>
          <p className="works-subtitle">
            Get started in minutes with our simple 4-step process
          </p>
        </div>

        {/* Steps Grid */}
        <Row className="g-4 steps-row">
          {steps.map((step, index) => (
            <Col lg={3} md={6} sm={6} xs={12} key={step.id}>
              <div 
                className="step-card"
                style={{ animationDelay: `${index * 0.2}s` }}
              >
                {/* Step Number Badge */}
                <div 
                  className="step-number-badge"
                  style={{ backgroundColor: step.color }}
                >
                  {step.number}
                </div>

                {/* Icon Container */}
                <div 
                  className="step-icon-container"
                  style={{ 
                    backgroundColor: `${step.color}15`,
                    borderColor: `${step.color}30`
                  }}
                >
                  <div 
                    className="step-icon"
                    style={{ color: step.color }}
                  >
                    {step.icon}
                  </div>
                </div>

                {/* Step Content */}
                <h3 className="step-title">{step.title}</h3>
                <p className="step-description">{step.description}</p>

                {/* Arrow Connector (except last card) */}
                {index < steps.length - 1 && (
                  <div className="step-arrow d-none d-lg-block">
                    <ArrowRight size={28} strokeWidth={2} />
                  </div>
                )}
              </div>
            </Col>
          ))}
        </Row>

      </Container>
    </section>
  );
};

export default HowItWorksSection;